export const CONFIGURATION = {
  breakpoints: {
    values: {
      xs: 300,
      sm: 768,
      md: 1024,
      lg: 1440,
      xl: 1920,
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  typography: {
    useNextVariants: true, //TODO: change to new spec: https://material-ui.com/style/typography/#migration-to-typography-v2
    suppressDeprecationWarnings: true,
    fontFamily: "'Lato', 'Helvetica', sans-serif",
  },
};
